export default __webpack_public_path__ + "static/media/foreverautumnlogo.292c8d47.png";